import { CSDLogo as Companylogo } from "../assets/data/icon_data";
const GlobalData = {
  company: {
    companyName: "Cyber Space Digital",
    companyPhone: "+918143407758",
    companyEmail: "mail@cyberspacedigital.in",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=918143407758",

    /*Social media */
    companyfacebook: "https://www.facebook.com/cyber.space.digital.fb/",
    companyinstagram: "https://www.instagram.com/cyber.space.digital/",
    companygit: "https://github.com/akhilthej/",
    companytwitter: "https://twitter.com/CyberSD1995/",
    companyyoutube: "https://twitter.com/CyberSD1995/",
    companylinkedin: "https://twitter.com/CyberSD1995/",
  },
};

export { GlobalData, Companylogo };
